export const INTEGRATION_STATES = ['active', 'paused', 'disabled'];
export const CREDENTIAL_STATES = ['active', 'inactive'];
export const ENDPOINT_STATES = ['active', 'paused', 'disabled'];
export const DELIVERY_STATES = ['queued', 'processing', 'succeeded', 'retrying', 'failed', 'cancelled'];

export const EVENT_GROUPS = [
  {
    key: 'contentLifecycle',
    events: [
      'file.created',
      'file.updated',
      'file.deleted',
      'file.moved',
      'folder.created',
      'folder.updated',
      'folder.deleted',
      'folder.moved',
    ],
  },
  {
    key: 'processingLifecycle',
    events: [
      'file.processing.completed',
      'file.processing.failed',
    ],
  },
  {
    key: 'linkLifecycle',
    events: [
      'share_link.created',
      'share_link.updated',
      'share_link.deleted',
      'upload_link.created',
      'upload_link.updated',
      'upload_link.deleted',
    ],
  },
];

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getStateColor = (state) => {
  switch (state) {
    case 'active': return 'light-blue-accent-4';
    case 'paused': return 'orange';
    case 'inactive': return 'grey';
    case 'disabled': return 'error';
    default: return 'grey';
  }
};

export const getDeliveryStatusColor = (status) => {
  switch (status) {
    case 'succeeded': return 'success';
    case 'failed': return 'error';
    case 'retrying': return 'orange';
    case 'processing': return 'info';
    case 'queued': return 'grey';
    case 'cancelled': return 'grey-darken-1';
    default: return 'grey';
  }
};

export const formatWebhookType = (type) => (type || '')
  .split('_')
  .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
  .join(' ');

export const getEventTranslationKey = (eventType) => eventType.replace(/\./g, '_');
